import React from "react";
import HeaderComponent from "../Registration/Components/HeaderComponent";
import DormantCancellationForm from "./Forms/DormantCancellationForm";
const DormantCancellation = () => {
  return (
    <div className="customerinformation">
      <HeaderComponent />
      <div className="container content">
        <div className="row">
          <div className="customerform_left col-lg-5">
            <h1>Cancel Dormant Subscription!</h1>
          </div>
          <div className="customerform_right col-lg-7">
            <DormantCancellationForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DormantCancellation;
